import { useState } from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ProductModal from '../components/ProductModal'
import SEO from '../components/SEO'
import { products } from '../data/products'

export default function Shop({ onLoginClick }) {
  const [selectedProduct, setSelectedProduct] = useState(null)

  const inStock = products.filter(p => p.availability === 'IN STOCK')
  const soldOut = products.filter(p => p.availability === 'SOLD OUT')

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO
        title="Shop"
        description="Shop DOTTEDLINE magazines, posters, and football culture merchandise. Print culture, delivered."
        url="/shop"
      />
      <Navbar onLoginClick={onLoginClick} variant="light" />

      <main className="flex-1 pt-32 pb-24 px-6">
        <div className="max-w-6xl mx-auto">
          <header className="mb-16">
            <h1 className="text-4xl md:text-5xl mb-4">
              Shop
            </h1>
            <p className="text-xl text-gray-600">
              Print. Culture. Delivered.
            </p>
          </header>

          {/* In Stock */}
          {inStock.length > 0 && (
            <section className="mb-20">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {inStock.map((product) => (
                  <button
                    key={product.id}
                    onClick={() => setSelectedProduct(product)}
                    className="group text-left"
                  >
                    <div className="aspect-[3/4] bg-gray-100 mb-4 overflow-hidden">
                      <img
                        src={product.image}
                        alt={product.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        onError={(e) => {
                          e.target.style.display = 'none'
                        }}
                      />
                    </div>
                    <h3 className="font-medium text-sm mb-1 group-hover:text-gray-600 transition-colors">
                      {product.title}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      £{product.price}
                    </p>
                  </button>
                ))}
              </div>
            </section>
          )}

          {/* Sold Out */}
          {soldOut.length > 0 && (
            <section>
              <h2 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-8">
                Archive — Sold Out
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {soldOut.map((product) => (
                  <button
                    key={product.id}
                    onClick={() => setSelectedProduct(product)}
                    className="group text-left opacity-60 hover:opacity-80 transition-opacity"
                  >
                    <div className="aspect-[3/4] bg-gray-100 mb-4 overflow-hidden relative">
                      <img
                        src={product.image}
                        alt={product.title}
                        className="w-full h-full object-cover grayscale"
                        onError={(e) => {
                          e.target.style.display = 'none'
                        }}
                      />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <span className="bg-white px-4 py-2 text-xs font-medium tracking-wider">
                          SOLD OUT
                        </span>
                      </div>
                    </div>
                    <h3 className="font-medium text-sm mb-1">
                      {product.title}
                    </h3>
                    <p className="text-gray-400 text-sm">
                      Sold Out
                    </p>
                  </button>
                ))}
              </div>
            </section>
          )}
        </div>
      </main>

      <Footer />

      <ProductModal
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
      />
    </div>
  )
}
